/**
 * Created by jgolebiewski on 19.10.2015.
 */
common.factory('sectionFieldsResource', ['$resource', function ($resource) {
  return $resource('/sectionFields');
}]);